/** Reads the roles from the token for showing and hiding menus only. The server checks every request itself. */
export function rolesOf(token: string | null): string[] {
  if (!token) return []
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return Array.isArray(payload.roles) ? payload.roles : []
  } catch {
    return []
  }
}

export const STAFF_ROLES = ['ADMISSIONS_ADMIN', 'CONTENT_ADMIN', 'PANEL_REVIEWER', 'SUPER_ADMIN']

export function homeFor(roles: string[]): string {
  if (roles.some((r) => ['ADMISSIONS_ADMIN', 'PANEL_REVIEWER', 'SUPER_ADMIN'].includes(r))) return '/dashboard'
  if (roles.includes('CONTENT_ADMIN')) return '/content'
  return '/login'
}
